import React from 'react';
import Modal from 'simple-react-modal';

import './PayPerViewPurchaseModal.css';
import { observer } from 'mobx-react';

import PayPerViewStore from '../../store/PayPerViewStore';
import { buildAnchorLink } from '../../utils/helpers';

const AccountPackages = React.lazy(() => import('../accountComponents/AccountPackages'));


@observer
class PayPerViewPurchaseModal extends React.Component {

  closeModal = () => {
    PayPerViewStore.setShowPayPerViewModal(false);
  };

  render() {
    const {
      anchorsWithClipStore,
      title,
      price,
      user,
      anchorId,
      buyClip,
      type,
      clipId,
      programs,
      anchorName,
      openPurchased,
      closeModal,
      startPurchaseTimer,
    } = this.props;
    const showModal = PayPerViewStore.showPayPerViewModal;
    const currentAnchor = anchorsWithClipStore.find((anchor) => anchor.id === PayPerViewStore.currentlySelectedAnchorID);
    const anchorShortUrl = buildAnchorLink({
      id: (currentAnchor?.id || anchorId),
      name: (currentAnchor?.name || anchorName),
    });

    return (
      <Modal className="pay-per-view-modal-container" closeOnOuterClick={true} show={showModal} onClose={this.closeModal}>
        <div className="pay-per-view-modal">
          {programs.length > 0 ? 
          <React.Suspense fallback={null}>
            <AccountPackages
              activeCampaign={{}}
              anchorName={PayPerViewStore.currentlySelectedAnchor || anchorName}
              anchorShortUrl={anchorShortUrl}
              anchorToSubscribe={PayPerViewStore.currentlySelectedAnchorID.toString() || anchorId.toString()}
              buyClip={buyClip}
              clipId={clipId}
              closeModal={closeModal}
              disableOneClickPaysafe={false}
              isGift={false}
              isItem={true}
              message={PayPerViewStore.message}
              openPurchased={openPurchased}
              price={price}
              programs={programs}
              returnPath={`${window.location.pathname}`}
              startPurchaseTimer={startPurchaseTimer}
              title={title}
              type={type}
              user={user}
            />
          </React.Suspense>
          : null
          }
        </div>
      </Modal>
    );
  }
}

export default PayPerViewPurchaseModal;
